import React from 'react';
import { useTranslation } from '@hooks/useTranslation';
import { useNotification } from '@hooks/useNotification';
import Modal from '@components/common/Modal';
import RefillForm from '@components/common/forms/RefillForm';
import api from '@services/api';
import './RefillModal.scss';

export const RefillModal = ({
    isOpen,
    onClose,
    resource = null,
    refill = null,
    mode = 'create', // 'create', 'edit'
    onSuccess
}) => {
    const { t } = useTranslation();
    const notify = useNotification();

    const handleSubmit = async (formData) => {
        try {
            let response;
            const submitData = {
                quantity_added: formData.quantity_added,
                notes: formData.notes || null
            };

            if (mode === 'edit' && refill) {
                response = await api.refills.update(refill.id, submitData);
                notify.success(t('refill.updated_successfully'));
            } else {
                response = await api.refills.create({
                    resource_id: resource.id,
                    ...submitData
                });
                notify.success(t('refill.added_successfully'));
            }

            onSuccess(response.data);
            onClose();
        } catch (err) {
            console.error('Failed to process refill:', err);
            throw err; // Re-throw to let form handle the error
        }
    };

    const getModalTitle = () => {
        return mode === 'edit' ? t('refill.edit_refill') : t('refill.add_refill');
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={getModalTitle()}
            className="refill-modal"
        >
            <RefillForm
                refill={refill}
                resource={resource}
                isEditing={mode === 'edit'}
                onSubmit={handleSubmit}
                onCancel={onClose}
            />
        </Modal>
    );
};

export default RefillModal;
